import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { MenuDropdownContext } from "./MenuContext";
import { SubMenu as SubMenuInner } from "@szhsin/react-menu";
export function SubMenu(props) {
    const { menuItemHoverClassName, menuItemDisabledClassName, menuItemWithSubMenuClassName, menuClassName, menuItemClassName } = React.useContext(MenuDropdownContext);
    const { className, menuClassName: menuClassName$, label, ...rest } = props;
    const menuItemClassNameFn = ({ hover, disabled, submenu }) => {
        const array = [];
        if (className)
            array.push(className);
        if (menuItemClassName)
            array.push(menuItemClassName);
        if (hover && menuItemHoverClassName)
            array.push(menuItemHoverClassName);
        if (disabled && menuItemDisabledClassName)
            array.push(menuItemDisabledClassName);
        if (submenu && menuItemWithSubMenuClassName)
            array.push(menuItemWithSubMenuClassName);
        return array.join(" ");
    };
    return _jsx(SubMenuInner, { ...rest, label: _jsxs(_Fragment, { children: [label, _jsx("svg", { className: "ml-auto", height: "1em", width: ".5em", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", viewBox: "60 100 304 312", children: _jsx("path", { d: "M342.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L274.7 256 105.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" }) })] }), menuClassName: menuClassName$ ?? menuClassName, itemProps: { className: menuItemClassNameFn } });
}
